export default {
  'EditArtistOverviewSocial.saved': { en: 'Saved', fr: 'Enregistrée' },
  'EditArtistOverviewSocial.title': { en: 'Social', fr: 'Sociale' },
};
